import { render, staticRenderFns } from "./StoresComponent.vue?vue&type=template&id=622b8792&"
import script from "./StoresComponent.vue?vue&type=script&lang=js&"
export * from "./StoresComponent.vue?vue&type=script&lang=js&"
import style0 from "./StoresComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports